/* Pure geometry for the sign-in web graph, kept apart from the canvas so it can be tested. */

export type GraphNode = { x: number; y: number; vx: number; vy: number };

export function createNodes(count: number, width: number, height: number, rand: () => number = Math.random): GraphNode[] {
  return Array.from({ length: count }, () => ({
    x: rand() * width,
    y: rand() * height,
    vx: (rand() - 0.5) * 0.35,
    vy: (rand() - 0.5) * 0.35,
  }));
}

/** Drift every node by its velocity, wrapping at the edges so the field never empties. */
export function stepNodes(nodes: GraphNode[], width: number, height: number, dt = 1): void {
  for (const n of nodes) {
    n.x += n.vx * dt;
    n.y += n.vy * dt;
    if (n.x < 0) n.x += width;
    else if (n.x > width) n.x -= width;
    if (n.y < 0) n.y += height;
    else if (n.y > height) n.y -= height;
  }
}

/** The `limit` nodes nearest the point, closest first, none farther than `radius`. */
export function nearestNodes(
  nodes: GraphNode[], px: number, py: number, limit: number, radius: number,
): { node: GraphNode; dist: number }[] {
  const found: { node: GraphNode; dist: number }[] = [];
  for (const node of nodes) {
    const dist = Math.hypot(node.x - px, node.y - py);
    if (dist <= radius) found.push({ node, dist });
  }
  return found.sort((a, b) => a.dist - b.dist).slice(0, limit);
}

export const NODE_LINK_DISTANCE = 110;
export const POINTER_RADIUS = 190;
export const POINTER_LINKS = 6;
